export default "/images/vendor/flag-icon-css/flags/4x3/vu.svg?f55d4352a21eeff37a90f0aeb663cfb1";